// extracted by mini-css-extract-plugin
export default {"profileContainer":"index_profileContainer__twk3t"};